import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToTime'
})
export class NumberToTimePipe implements PipeTransform {

  transform(value: number): string {

    let seconds = value;
    let minutes = Math.floor((seconds / 1000) / 60);

    seconds = seconds - (minutes * 1000 * 60);
    seconds = Math.floor(seconds / 1000);

    return `${minutes}m ${seconds.toString().padStart(2, "0")}s`;
  }

}
